module.exports = __webpack_public_path__ + "static/media/skiing-nordic.95357a5c.svg";